if (!window.__mgSwatchHoverInit) {
  window.__mgSwatchHoverInit = true;

  function mgSwatchImg(btn) {
    return btn.closest('.mg-product-card')?.querySelector('.mg-product-card__img');
  }

  function mgSwatchOver(event) {
    const btn = event.target.closest('[data-mg-swatch]');
    if (!btn) return;
    const img = mgSwatchImg(btn);
    if (!img) return;
    if (img.dataset.mgOrigSrc === undefined) {
      img.dataset.mgOrigSrc = img.getAttribute('src') || '';
      img.dataset.mgOrigSrcset = img.getAttribute('srcset') || '';
    }
    img.removeAttribute('srcset');
    img.setAttribute('src', btn.dataset.mgSwatchSrc);
  }

  function mgSwatchOut(event) {
    const btn = event.target.closest('[data-mg-swatch]');
    if (!btn) return;
    const img = mgSwatchImg(btn);
    if (!img || img.dataset.mgOrigSrc === undefined) return;
    img.setAttribute('src', img.dataset.mgOrigSrc);
    if (img.dataset.mgOrigSrcset) img.setAttribute('srcset', img.dataset.mgOrigSrcset);
  }

  document.addEventListener('mouseover', mgSwatchOver);
  document.addEventListener('mouseout', mgSwatchOut);
  document.addEventListener('focusin', mgSwatchOver);
  document.addEventListener('focusout', mgSwatchOut);
}
